// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e6tyCMnDIrUdf0GskKde{border-radius:0 6px 6px 0;width:100%;height:6px;overflow:hidden}.e6tyCMnDIrUdf0GskKde.uhQVu0tpQjHd4PzCoxlQ{background:var(--black-20);border-radius:6px}.e6tyCMnDIrUdf0GskKde.bcBtYmVMQE4FCVsKW2fZ{border-radius:6px}.e6tyCMnDIrUdf0GskKde .kgdq7ltnCtUJj1MPMEbS{background-color:var(--content-brand-primary);border-radius:0 6px 6px 0;height:100%;transition:all .5s}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `e6tyCMnDIrUdf0GskKde`,
	"withBg": `uhQVu0tpQjHd4PzCoxlQ`,
	"allBorders": `bcBtYmVMQE4FCVsKW2fZ`,
	"progress": `kgdq7ltnCtUJj1MPMEbS`
};
export default ___CSS_LOADER_EXPORT___;
